<template>
  <div>
    <div
      class="h-13 flex"
      @mouseover="hoverState = true"
      @mouseleave="hoverState = false"
    >
      <div class="sticky z-10 pl-6 flex bg-slate-100" :style="{ left }">
        <div
          class="w-60 px-4 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300 border-l border-r gap-2 "
          :class="[
            isLast ? 'rounded-bl' : '',
            useSelect ? 'cursor-pointer' : '',
            hoverState ? 'bg-hover-state' : 'bg-pure-white'
          ]"
          @click="$emit('change-select')"
          :title="creditPackage.name"
        >
          <BlInputRadio
            v-if="useSelect"
            :checked="selected"
            name="select_package_id"
            class="flex-shrink-0"
            style="margin: 0"
          />
          <BlTextBody2
            :text="creditPackage.name"
            class="truncate text-slate-1000"
          />
        </div>
      </div>
      <div
        class="w-32 px-4 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']"
      >
        <BlTextBody2 :text="creditPackage.number_of_items" />
      </div>
      <div
        class="w-32 px-4 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']"
      >
        <BlChip
          :chip="packageChips[creditPackage.status].chip"
          :color="packageChips[creditPackage.status].color"
          dense
        />
      </div>
      <div
        class="w-32 px-4 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300 justify-between"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']"
      >
        <BlTextBody2 :text="creditPackage.total_credits" />
      </div>
      <div
        class="w-40 px-4 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300 justify-between"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']"
      >
        <BlTextBody2 :text="currentCenter.currency_sym" />
        <BlTextBody2 :text="priceFormats(creditPackage.total_price)" />
      </div>
      <div
        class="w-40 px-4 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']"
      >
        <BlTextBody2 :text="expirationDate" />
      </div>
      <div
        class="w-40 px-4 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']"
      >
        <BlTextBody2 :text="rescheduleCredit" />
      </div>
      <div
        class="w-100 px-4 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300 flex-grow"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']"
      >
        <BlTextBody2
          :title="creditPackage.description"
          :text="creditPackage.description || '-'"
          class="truncate whitespace-pre-line"
        />
      </div>
      <div class="sticky right-0 z-10 pr-6 flex bg-slate-100">
        <div
          class="flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300 border-r justify-center"
          :class="[
            isLast ? 'rounded-br' : '',
            useAction ? 'w-32' : 'w-4',
            hoverState ? 'bg-hover-state' : 'bg-pure-white'
          ]"
        >
          <router-link
            v-if="useAction"
            :to="`/center/package/${creditPackage.id}`"
          >
            <BlInputButton type="outlined" dense label="View package" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { displayPrice } from "@/plugins/helper.js";

import BlTextBody2 from "../../BlTextBody2.vue";
import BlChip from "../../BlChip.vue";
import BlInputButton from "../../BlInputButton.vue";
import BlInputRadio from "../../BlInputRadio.vue";

export default {
  name: "PackageItem",
  components: {
    BlTextBody2,
    BlChip,
    BlInputButton,
    BlInputRadio
  },
  props: {
    creditPackage: { type: Object, required: true },
    isLast: { default: false },
    left: { type: String, default: "0rem" },
    useAction: { type: Boolean, default: false },
    useSelect: { type: Boolean, default: false },
    selected: { type: Boolean, default: false }
    // @change-select(value)
  },
  data() {
    return {
      hoverState: false,
      //
      packageChips: {
        active: { chip: "Active", color: "lime" },
        archived: { chip: "Archived", color: "rose" }
      },
      menuOpened: false,
      deleteLoading: false
    };
  },
  computed: {
    ...mapGetters(["currentCenter"]),
    expirationDate() {
      if (this.creditPackage.expiration_date === null) {
        return "No expiration date";
      }
      return `${this.creditPackage.expiration_date} day(s)`;
    },
    rescheduleCredit() {
      if (this.creditPackage.reschedule_credit === null) {
        return "Unlimited";
      }
      return `${this.creditPackage.reschedule_credit} time(s)`;
    }
  },
  watch: {
    menuOpened(val) {
      if (val) {
        setTimeout(() => {
          window.addEventListener("click", this.closeHandler);
        }, 10);
      }
    }
  },
  methods: {
    ...mapActions([""]),
    displayPrice,
    priceFormats(price = 0) {
      const settings = this.currentCenter.currency_settings;
      return this.displayPrice({ settings, price });
    },
    closeHandler() {
      window.removeEventListener("click", this.closeHandler);
      this.menuOpened = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/center/package/Item.vue